import { render, staticRenderFns } from "./BuildingEditOptionSettingsTab.vue?vue&type=template&id=6a04c061"
import script from "./BuildingEditOptionSettingsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditOptionSettingsTab.vue?vue&type=script&lang=ts"
import style0 from "./BuildingEditOptionSettingsTab.vue?vue&type=style&index=0&id=6a04c061&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports